import classNames from 'classnames'
import Translate from 'lang/Translate'

const JSError = ({ isModal = false }) => {
    return (
        <div className={classNames("tile", { "is-parent is-vertical error-container": !isModal })}>
            { !isModal ? <div className="error-modal-title mb-3">
                <h1 className="title">
                    <Translate text="Content.title_default" />
                </h1>
            </div> : null }
            <div className="error-content margin-top-header mb-3">
                <Translate text="Content.provided_error" />
                <div>
                    <strong><Translate text="Content.BadRequestLabel" /></strong>
                </div>
                <div>
                    <Translate text="Content.Javascripterror_DescribeYourIssue" />
                </div>
            </div>
        </div>
    )
}

export default JSError